module.exports = __webpack_public_path__ + "static/z_tall_apples2-796d5ba12927e7e83b182c6c417001b6.jpg";